<template>
  <div>
    <el-alert
      title="运营管理员可按馆开启/关闭家长端内容模块；关闭后小程序、App、网页同步不展示。"
      type="info"
      :closable="false"
      show-icon
      style="margin-bottom: 16px"
    />
    <el-table :data="list" v-loading="loading" border>
      <el-table-column prop="clubCode" label="编码" width="120" />
      <el-table-column prop="clubName" label="名称" min-width="140" />
      <el-table-column label="内容模块" min-width="280">
        <template slot-scope="{ row }">
          <div class="mod-tags" v-if="row.contentModules">
            <el-tag size="mini" :type="row.contentModules.showcase ? 'success' : 'info'">首页轮播</el-tag>
            <el-tag size="mini" :type="row.contentModules.coaches ? 'success' : 'info'">教练</el-tag>
            <el-tag size="mini" :type="row.contentModules.showcaseMore ? 'success' : 'info'">球馆风采</el-tag>
            <el-tag size="mini" :type="row.contentModules.awards ? 'success' : 'info'">荣誉奖状</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120" fixed="right">
        <template slot-scope="{ row }">
          <el-button type="text" size="small" @click="openModules(row)">内容开关</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      :title="'内容模块 · ' + (moduleClub.clubName || moduleClub.clubCode || '')"
      :visible.sync="moduleVisible"
      width="460px"
      append-to-body
      destroy-on-close
    >
      <div class="mod-list">
        <div class="mod-row">
          <div>
            <div class="mod-name">首页轮播</div>
            <div class="mod-desc">小程序首页顶部大图</div>
          </div>
          <el-switch v-model="moduleForm.showcase" />
        </div>
        <div class="mod-row">
          <div>
            <div class="mod-name">教练团队</div>
            <div class="mod-desc">教练列表与详情</div>
          </div>
          <el-switch v-model="moduleForm.coaches" />
        </div>
        <div class="mod-row">
          <div>
            <div class="mod-name">球馆风采</div>
            <div class="mod-desc">首页风采列表，不含轮播</div>
          </div>
          <el-switch v-model="moduleForm.showcaseMore" />
        </div>
        <div class="mod-row">
          <div>
            <div class="mod-name">荣誉奖状</div>
            <div class="mod-desc">首页奖状</div>
          </div>
          <el-switch v-model="moduleForm.awards" />
        </div>
      </div>
      <div slot="footer">
        <el-button @click="moduleVisible=false">取消</el-button>
        <el-button type="primary" :loading="moduleSaving" @click="saveModules">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listPlatformClubs, updatePlatformContentModules } from '../api'

export default {
  name: 'Clubs',
  data() {
    return {
      loading: false,
      list: [],
      moduleVisible: false,
      moduleSaving: false,
      moduleClub: {},
      moduleForm: {
        showcase: true,
        coaches: true,
        showcaseMore: true,
        awards: true
      }
    }
  },
  created() {
    this.load()
  },
  methods: {
    async load() {
      this.loading = true
      try {
        const res = await listPlatformClubs()
        this.list = res.data || []
      } finally {
        this.loading = false
      }
    },
    openModules(row) {
      const m = row.contentModules || {}
      this.moduleClub = row
      this.moduleForm = {
        showcase: m.showcase !== false,
        coaches: m.coaches !== false,
        showcaseMore: m.showcaseMore !== false,
        awards: m.awards !== false
      }
      this.moduleVisible = true
    },
    async saveModules() {
      if (!this.moduleClub.clubId) return
      this.moduleSaving = true
      try {
        await updatePlatformContentModules(this.moduleClub.clubId, this.moduleForm)
        this.$message.success('内容模块已更新')
        this.moduleVisible = false
        this.load()
      } finally {
        this.moduleSaving = false
      }
    }
  }
}
</script>

<style scoped>
.mod-tags { display: flex; flex-wrap: wrap; gap: 4px; }
.mod-list { display: flex; flex-direction: column; }
.mod-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 4px;
  border-bottom: 1px solid #f1f5f9;
}
.mod-row:last-child { border-bottom: none; }
.mod-name { font-weight: 600; color: #0f172a; }
.mod-desc { font-size: 12px; color: #94a3b8; margin-top: 2px; }
</style>
